import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-contact-custom-brand',
  imports: [HeaderLatestComponent,PeopleflowFooterComponent],
  templateUrl: './contact-custom-brand.html',
  styleUrl: './contact-custom-brand.scss',
})
export class ContactCustomBrand {

}
